import React, { useEffect, useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { API_BY_COUNTRY } from './helper/comman';
import DispCatg from './component/DispCatg';
import DispMenu from './component/DispMenu';

const MenuPage = () => {
    const { storeid } = useParams();
    const [baseUrl, setBaseUrl] = useState('');
    const [products, setProducts] = useState({ catg: [], menu: [] });
    const [category, setCategory] = useState("All");
    const [loading, setLoading] = useState(true);
    const [storeInfo, setStoreInfo] = useState({ name: '', phone: '', address: '' });

    const theme = {
        primary: '#E65100',
        secondary: '#2E7D32',
        background: '#FFF8F1',
        surface: '#FFFFFF',
        textDark: '#263238',
        textLight: '#546E7A',
        accent: '#FFB74D'
    };

    useEffect(() => {
        const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        let region = timeZone.startsWith("Asia/") ? "India" : "Canada";
        const newUrl = API_BY_COUNTRY[region] || API_BY_COUNTRY["Canada"];
        setBaseUrl(newUrl);
    }, []);

    useEffect(() => {
        const fetchData = async () => {
            if (!baseUrl || !storeid) return;
            setLoading(true);
            try {
                const respStore = await axios.post(`${baseUrl}/getStoreInfo`, { storeID: storeid });
                var storeData = respStore.data.data || {};
                setStoreInfo({
                    name: storeData.name || `Store #${storeid}`,
                    phone: storeData.phone || 'N/A',
                    address: storeData.address || 'N/A'
                });
                const response = await axios.post(`${baseUrl}/getQRMenu`, { storeID: storeid });
                if (response.data.code === 0) setProducts(response.data.data);
            } catch (error) {
                console.error("POS API Error:", error);
            } finally {
                setLoading(false);
            }
        };
        fetchData();
    }, [storeid, baseUrl]);

    // Derived: Handle cases where catg or menu might be undefined/null
    const activeCategories = useMemo(() => {
        if (!products?.catg || !products?.menu) return [];
        return products.catg.filter(cat => products.menu.some(item => item.categoryID === cat._id));
    }, [products]);

    const filteredMenu = useMemo(() => {
        if (!products?.menu) return [];
        if (category === "All") return products.menu;
        const selectedCatObj = products.catg.find(c => c.catgory === category);
        return products.menu.filter(item => item.categoryID === selectedCatObj?._id);
    }, [category, products]);

    return (
        <div style={{ backgroundColor: theme.background, minHeight: '100vh', fontFamily: "'Segoe UI', Roboto, sans-serif", color: theme.textDark }}>
            <header style={{
                backgroundColor: theme.surface,
                padding: '30px 20px',
                textAlign: 'center',
                boxShadow: '0 4px 12px rgba(230, 81, 0, 0.08)',
                borderBottom: `3px solid ${theme.primary}`
            }}>
                <h1 style={{ margin: '0 0 5px 0', fontSize: '1.8rem', color: theme.textDark, letterSpacing: '-0.5px' }}>{storeInfo.name}</h1>
                <p style={{ margin: 0, fontSize: '0.9rem', color: theme.textLight }}>📍 {storeInfo.address}</p>
                <a href={`tel:${storeInfo.phone}`} style={{ display: 'inline-block', marginTop: '8px', fontSize: '0.95rem', color: theme.primary, textDecoration: 'none', fontWeight: '600', borderBottom: `1px dashed ${theme.primary}` }}>
                    📞 {storeInfo.phone}
                </a>
            </header>

            {loading && (
                <div style={{ height: '4px', width: '100%', backgroundColor: theme.accent, overflow: 'hidden', position: 'relative' }}>
                    <div style={{ position: 'absolute', height: '100%', width: '40%', backgroundColor: theme.primary, animation: 'load 1.5s infinite' }}></div>
                    <style>{`@keyframes load { from { left: -40%; } to { left: 100%; } }`}</style>
                </div>
            )}

            <main style={{ maxWidth: '1100px', margin: '0 auto', padding: '20px' }}>
                {!loading && (
                    <>
                        {/* 1. Handle case where store is completely empty */}
                        {activeCategories.length === 0 ? (
                            <div style={{ textAlign: 'center', padding: '100px 20px' }}>
                                <div style={{ fontSize: '64px' }}>🏪</div>
                                <h2 style={{ color: theme.textDark }}>Menu is currently unavailable</h2>
                                <p style={{ color: theme.textLight }}>This store hasn't published their menu yet. Please check back later!</p>
                            </div>
                        ) : (
                            <>
                                <DispCatg listCatg={activeCategories} category={category} setCategory={setCategory} theme={theme} />
                                <DispMenu menulist={filteredMenu} theme={theme} />
                            </>
                        )}
                    </>
                )}
            </main>
        </div>
    );
};

export default MenuPage;